<div class="p-6 max-w-lg">
    <div class="flex items-start gap-3 mb-5">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">confirmation_number</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'quickEasypass.settingsTitle' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ data.parkingSpace.name }}</p>
        </div>
    </div>

    <div class="flex items-center justify-between py-3 border-t border-slate-100">
        <div class="text-sm font-medium text-slate-900">{{ 'quickEasypass.enabled' | translate }}</div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
            <input type="checkbox" class="sr-only peer" [checked]="enabled()"
                   (change)="enabled.set($any($event.target).checked)" />
            <div class="w-11 h-6 bg-slate-200 rounded-full transition-colors peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-100 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:border after:border-slate-300 after:transition-all peer-checked:after:translate-x-5 peer-checked:after:border-white"></div>
        </label>
    </div>

    <div class="py-3 border-t border-slate-100">
        <div class="text-sm font-medium text-slate-900">{{ 'quickEasypass.payer' | translate }}</div>
        @if (hasOrganization) {
        <div class="text-sm text-slate-700 mt-1">{{ 'quickEasypass.payerAssigned' | translate }}</div>
        } @else {
        <div class="text-sm text-red-600 mt-1">{{ 'quickEasypass.payerMissing' | translate }}</div>
        }
    </div>

    @if (enabled()) {
    <div class="py-3 border-t border-slate-100">
        <label class="text-sm font-medium text-slate-900" for="qe-cutoff">{{ 'quickEasypass.cutoff' | translate }}</label>
        <input id="qe-cutoff" type="time"
               class="mt-2 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
               [ngModel]="cutoff()" (ngModelChange)="cutoff.set($event)" />
    </div>

    <div class="flex items-center justify-between py-3 border-t border-slate-100">
        <div class="text-sm font-medium text-slate-900">{{ 'quickEasypass.chargeAfterCutoff' | translate }}</div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
            <input type="checkbox" class="sr-only peer" [checked]="chargeAfterCutoff()"
                   (change)="chargeAfterCutoff.set($any($event.target).checked)" />
            <div class="w-11 h-6 bg-slate-200 rounded-full transition-colors peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-100 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:border after:border-slate-300 after:transition-all peer-checked:after:translate-x-5 peer-checked:after:border-white"></div>
        </label>
    </div>
    }

    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ 'common.cancel' | translate }}</jjames-button>
        <jjames-button variant="primary" [disabled]="!canSave()" [loading]="isSaving()" (clicked)="onSave()">
            {{ 'common.save' | translate }}
        </jjames-button>
    </div>
</div>
